export const GET_HOME = 'GET_HOME' as const
export const GET_HOME_STARTED = 'GET_HOME_STARTED' as const
export const GET_HOME_SUCCEEDED = 'GET_HOME_SUCCEEDED' as const

export const GET_HOME_SECTION_CONTENTS = 'GET_HOME_SECTION_CONTENTS' as const
export const GET_HOME_SECTION_CONTENTS_SUCCEEDED = 'GET_HOME_SECTION_CONTENTS_SUCCEEDED' as const
